import { AlertTriangle } from "lucide-react";

// Ranks the universe by positioning crowding (COT Index distance from 50).
// High index (crowded long) = contrarian downside risk; low index (crowded short) = upside risk.
export default function CotExtremes({ rows = [], onSelect }) {
  const ranked = rows
    .filter((r) => r.cot_index_1y != null)
    .map((r) => ({ ...r, _dist: Math.abs(r.cot_index_1y - 50) }))
    .sort((a, b) => b._dist - a._dist)
    .slice(0, 6);

  if (ranked.length === 0) return null;

  return (
    <div className="border border-zinc-800 bg-[#09090B]" data-testid="cot-extremes-card">
      <div className="px-3 py-2 border-b border-zinc-800 flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-widest text-zinc-400 flex items-center gap-1.5">
          <AlertTriangle size={11} strokeWidth={1.5} className="text-amber-term" /> COT Extremes · Crowding
        </span>
        <span className="text-[11px] uppercase tracking-widest text-zinc-600">
          spec positioning · 1yr percentile · contrarian
        </span>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 divide-x divide-y divide-zinc-900">
        {ranked.map((r) => {
          const long = r.cot_index_1y >= 50;
          const extreme = r.extreme != null;
          const dirCls = long ? "text-neg" : "text-pos";
          const label = long ? "CROWDED LONG" : "CROWDED SHORT";
          const implication = long ? "downside risk" : "upside risk";
          return (
            <button
              key={r.code}
              type="button"
              onClick={() => onSelect?.(r.code)}
              data-testid={`extreme-${r.symbol}`}
              className="text-left px-3 py-2 hover:bg-zinc-900 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="text-[12px] font-semibold text-amber-term">{r.symbol}</span>
                <span className="tabular-nums text-[13px] font-semibold text-zinc-100">
                  {Math.round(r.cot_index_1y)}
                </span>
              </div>
              <div className="flex items-center justify-between mt-0.5">
                <span
                  className={`text-[11px] uppercase tracking-widest ${dirCls} ${
                    extreme ? "font-semibold" : "opacity-80"
                  }`}
                >
                  {extreme && "⚠ "}{label}
                </span>
                {r.net_zscore != null && (
                  <span className="tabular-nums text-[11px] text-zinc-500">
                    {r.net_zscore > 0 ? "+" : ""}{r.net_zscore}σ
                  </span>
                )}
              </div>
              <div className="text-[11px] uppercase tracking-widest text-zinc-600 mt-0.5">
                contrarian {implication}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
